<template>
	<app-button v-if="status" :size="tablet ? 'small' : 'x-small'" :theme="theme">
		<font-awesome-icon icon="fa-note-sticky" class="text-md" />
	</app-button>
</template>

<script lang="ts" setup>
	import { computed } from 'vue'

	const props = defineProps({
		status: {
			type: Object,
			default: undefined
		},
		tablet: {
			type: Boolean,
			default: false
		}
	})

	const theme = computed(() => {
		if (!props.status || !props.status.notes) {
			return 'outline'
		}

		if (props.status.notes_status == 1) {
			return 'primary'
		}

		if (props.status.notes_status == 3) {
			return 'success'
		}

		if (props.status.notes_status == 4) {
			return 'warning'
		}

		if (props.status.notes_status == 2 || props.status.notes_status == 0) {
			return 'danger'
		}

		if (props.status.notes && props.status.notes_status === null) {
			return 'danger'
		}

		return 'outline'
	})
</script>
